/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type GcpRoleAndPrincipalOperationEnum = 'ADD' | 'REMOVE';

export const GcpRoleAndPrincipalOperationEnum = {

    ADD: 'ADD' as GcpRoleAndPrincipalOperationEnum,

    REMOVE: 'REMOVE' as GcpRoleAndPrincipalOperationEnum
};

